export default "__VITE_ASSET__D3n9AhKN__"